import DataManager from '../data/DataManager'

const tweet = (ogpText) => {
  //ShareするURL
  const config = DataManager.instance.getData('config')
  const ogpUrl = config.SHARE_URL
  const url =
    'http://twitter.com/intent/tweet?text=' +
    decodeURI(ogpText + ogpUrl) +
    '&hashtags=' +
    decodeURI('おぎわら遊技場') +
    ',' +
    decodeURI('DPZ')
  window.open(url, '_blank')
}

const ShareUtil = {
  tweet: tweet,
}
export default ShareUtil
